import CRMNavigation from "@/components/CRMNavigation";
import Footer from "@/components/Footer";
import { motion } from "framer-motion";


export default function FeaturePage() {
  // Define fade-up animation
  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <div className="min-h-screen bg-background" style={{ fontFamily: "'Roboto', sans-serif" }}>
      <CRMNavigation />

      {/* ================= HERO – DARK, GLASS, PREMIUM ================= */}
      <section className="relative min-h-[90vh] flex items-center overflow-hidden bg-[#040814] text-white py-24">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_#1d4ed8_0%,transparent_45%)] opacity-40"></div>
          <div className="absolute bottom-0 left-0 w-[450px] h-[350px] bg-blue-500/20 rounded-full blur-[120px]"></div>
          <div className="absolute top-10 right-0 w-[450px] h-[350px] bg-purple-500/20 rounded-full blur-[120px]"></div>
        </div>

        <div className="container mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center relative z-10">
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.6 }}
          >
            <span className="px-4 py-1 rounded-full text-sm bg-white/10 border border-white/20">
              Premium CRM Experience
            </span>

            <h1 className="mt-6 text-4xl md:text-5xl font-black leading-tight">
              Features of CRM
            </h1>

            <p className="mt-5 text-white/80 leading-relaxed">
              The primary moto behind CRM (Customer Relationship Management) is to help organizations deal with their association with clients and increment benefit. CRM lead generation system can help that procedure by sorting out important data. What are the features of CRM system and what highlights does effective CRM software contain?
            </p>
          </motion.div>

          <div className="relative">
            <motion.div
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              transition={{ duration: 0.6, delay: 0.15 }}
            >
              <div className="absolute inset-0 rounded-3xl bg-white/10 backdrop-blur-2xl border border-white/20 shadow-2xl -rotate-2"></div>

              <img
                src="/crm-software.png"
                className="relative rounded-3xl shadow-2xl border border-white/20"
                alt="CRM"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* ================= MULTICHANNEL — LIGHT, CARDS ================= */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6 text-center max-w-4xl">
          <motion.h2
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.6 }}
            className="text-3xl md:text-4xl font-extrabold text-slate-900"
          >
            Multichannel CRM
          </motion.h2>

          <motion.p
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.6, delay: 0.1 }}
            className="mt-4 text-slate-600"
          >
            Now you can connect with your customers by different channels like from email, live chat, and social media also. We want from best CRM software to manage the depth, value, and diversity of that relationship to build loyalty and ROI with customers. It can be done in multichannel CRM.
          </motion.p>
        </div>

        <div className="container mx-auto px-6 mt-12 grid gap-6 md:grid-cols-2 max-w-6xl">
          {/* Calling Card */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.6, delay: 0.2 }}
            className="rounded-3xl border bg-gradient-to-b from-white to-slate-50 p-6 shadow-xl hover:shadow-2xl transition"
          >
            <div className="h-12 w-12 rounded-full bg-blue-100 flex items-center justify-center mx-auto mb-4 text-2xl">
              📞
            </div>

            <h3 className="text-lg font-semibold text-slate-900">Calling</h3>

            <p className="mt-2 text-sm text-slate-600 leading-6">
              Contact customers over the phone inside CRM, with a single click. By integrating your call management applications with Variable soft CRM, you save time with automatic call logging and call analytics features.
            </p>
          </motion.div>

          {/* Email Card */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.6, delay: 0.3 }}
            className="rounded-3xl border bg-gradient-to-b from-white to-slate-50 p-6 shadow-xl hover:shadow-2xl transition"
          >
            <div className="h-12 w-12 rounded-full bg-blue-100 flex items-center justify-center mx-auto mb-4 text-2xl">
              ✉️
            </div>

            <h3 className="text-lg font-semibold text-slate-900">Email</h3>

            <p className="mt-2 text-sm text-slate-600 leading-6">
              Email ought to be the pillar of any relationship-advertising program. Of all reaction media, email gives the most noteworthy ROI. See your emails organized according to the CRM.
            </p>
          </motion.div>
        </div>
      </section>

      {/* ================= CUSTOMIZATION — DARK GRADIENT ================= */}
      <section className="relative overflow-hidden bg-[#040814] text-white">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_#2563eb_0%,transparent_55%)] opacity-30"></div>

        <div className="container mx-auto px-6 py-20 text-center max-w-4xl relative z-10">
          <motion.h3
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.6 }}
            className="text-3xl md:text-4xl font-extrabold"
          >
            Customization
          </motion.h3>

          <motion.p
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.6, delay: 0.1 }}
            className="mt-4 text-white/85 leading-relaxed"
          >
            Customize standard modules, include extra functionalities, and make CRM work the manner in which you do. With custom views, filters, and fields, choose how much information you need to see at some random time, and in the language, you like; you can also add some extra feature according to your organization with our Fully Customized CRM development services.
          </motion.p>
        </div>
      </section>

      {/* ================= PERFORMANCE — WHITE, CLEAN ================= */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6 text-center max-w-4xl">
          <motion.h2
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.6 }}
            className="text-3xl md:text-4xl font-extrabold text-slate-900"
          >
            Performance & Analytics
          </motion.h2>

          <motion.p
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.6, delay: 0.1 }}
            className="mt-4 text-slate-600"
          >
            Data-driven insights that help you scale faster and smarter.
          </motion.p>
        </div>

        <div className="container mx-auto px-6 mt-12 grid gap-6 md:grid-cols-2 max-w-6xl">
          {/* Card 1 - Analytics */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.6, delay: 0.2 }}
            className="rounded-3xl border bg-white p-6 shadow-xl hover:shadow-2xl transition"
          >
            <div className="h-12 w-12 rounded-full bg-blue-100 flex items-center justify-center mx-auto mb-4 text-blue-600">
              <svg
                className="h-8 w-8"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path d="M3 3v18h18" />
                <path d="M7 13v5" />
                <path d="M12 9v9" />
                <path d="M17 5v13" />
              </svg>
            </div>
            <h3 className="mt-3 text-lg font-semibold text-slate-900">Analytics</h3>
            <p className="mt-2 text-sm text-slate-600 leading-6">
              Create dashboards, analyze trends, stay connected to best performance indicators, and know where you stand on your targets. From lead analytics to deal insights, task details, and email analytics.
            </p>
          </motion.div>

          {/* Card 2 - Reports */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.6, delay: 0.3 }}
            className="rounded-3xl border bg-white p-6 shadow-xl hover:shadow-2xl transition"
          >
            <div className="h-12 w-12 rounded-full bg-blue-100 flex items-center justify-center mx-auto mb-4 text-blue-600">
              <svg
                className="h-8 w-8"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path d="M4 4h16v16H4z" />
                <path d="m22 6-10 7L2 6" />
              </svg>
            </div>
            <h3 className="mt-3 text-lg font-semibold text-slate-900">Reports</h3>
            <p className="mt-2 text-sm text-slate-600 leading-6">
              Detailed sales, campaign & activity reports in one click, giving you insights into various metrics such as sales trends, marketing efforts, and team performance.
            </p>
          </motion.div>
        </div>
      </section>

      {/* ================= SECURITY — DARK WITH GLOW ================= */}
      <section className="relative overflow-hidden bg-[#040814] text-white">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom,_#2563eb_0%,transparent_60%)] opacity-30"></div>

        <div className="container mx-auto px-6 py-20 text-center max-w-4xl relative z-10">
          <motion.h3
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.6 }}
            className="text-3xl md:text-4xl font-extrabold"
          >
            Security
          </motion.h3>

          <motion.p
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.6, delay: 0.1 }}
            className="mt-4 text-white/85 leading-relaxed"
          >
            Security must be the first priority of every organization. Every customer is data is valuable for them. We understand every organization must strike the right balance between protecting their customers' data and giving employees the freedom to get their work done. Variable soft CRM meets both of these requirements.
          </motion.p>
        </div>
      </section>

      {/* ================= LEAD MANAGEMENT — LIGHT CARDS ================= */}
        <section className="py-20 bg-white">
      <div className="container mx-auto px-6 text-center max-w-4xl">
        <motion.h2
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          transition={{ duration: 0.6 }}
          className="text-3xl md:text-4xl font-extrabold text-slate-900"
        >
          Lead Management System
        </motion.h2>

        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-4 text-slate-600"
        >
          Capture, track and convert leads — faster than ever.
        </motion.p>
      </div>

      <div className="container mx-auto px-6 mt-12 grid gap-6 md:grid-cols-3 max-w-6xl">
        {/* Card 1 - Lead Management */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          transition={{ duration: 0.6 }}
          className="rounded-3xl border bg-white p-6 shadow-xl"
        >
          <div className="h-16 w-16 rounded-full bg-blue-100 flex items-center justify-center mx-auto mb-4 text-blue-600">
            <i className="fas fa-tasks fa-2x"></i> {/* Font Awesome Icon for Lead Management */}
          </div>
          <h4 className="text-xl font-semibold text-slate-900">Lead Management</h4>
          <p className="mt-2 text-sm text-slate-600">
            Manage leads, score them, identify the ones that will convert, and follow up with context and services.
          </p>
        </motion.div>

        {/* Card 2 - Contact Management */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          transition={{ duration: 0.6 }}
          className="rounded-3xl border bg-white p-6 shadow-xl"
        >
          <div className="h-16 w-16 rounded-full bg-blue-100 flex items-center justify-center mx-auto mb-4 text-blue-600">
            <i className="fas fa-address-book fa-2x"></i> {/* Font Awesome Icon for Contact Management */}
          </div>
          <h4 className="text-xl font-semibold text-slate-900">Contact Management</h4>
          <p className="mt-2 text-sm text-slate-600">
            Get real-time insights about your customers, engage with them, and build stronger relationships.
          </p>
        </motion.div>

        {/* Card 3 - Lead Tracker */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          transition={{ duration: 0.6 }}
          className="rounded-3xl border bg-white p-6 shadow-xl"
        >
          <div className="h-16 w-16 rounded-full bg-blue-100 flex items-center justify-center mx-auto mb-4 text-blue-600">
            <i className="fas fa-search fa-2x"></i> {/* Font Awesome Icon for Lead Tracker */}
          </div>
          <h4 className="text-xl font-semibold text-slate-900">Lead Tracker</h4>
          <p className="mt-2 text-sm text-slate-600">
            Track your leads, assess their potential, and save time by focusing on the most promising opportunities.
          </p>
        </motion.div>
      </div>
    </section>
      <Footer />
    </div>
  );
}
